module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rates"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteInvestmentRate(_vm.rateObject.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentRate(_vm.rateObject)
      }
    },
    model: {
      value: (_vm.rateObject.title),
      callback: function($$v) {
        _vm.$set(_vm.rateObject, "title", $$v)
      },
      expression: "rateObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Описание",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateInvestmentRate(_vm.rateObject)
      }
    },
    model: {
      value: (_vm.rateObject.description),
      callback: function($$v) {
        _vm.$set(_vm.rateObject, "description", $$v)
      },
      expression: "rateObject.description"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": ("e" + (_vm.rateObject.id))
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8201778"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndividualInvestment/InvestmentRate.vue
// module id = 1005
// module chunks = 0